import { STORAGE_KEY_PREFIX } from "../../shared/examSession/constants";

export function clearExamSessionStorage(): void {
  try {
    const keys: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (k && k.startsWith(STORAGE_KEY_PREFIX)) keys.push(k);
    }
    keys.forEach((k) => localStorage.removeItem(k));
  } catch {
    // localStorage can throw in private mode or when disabled by the user;
    // logout must still proceed, so we ignore the failure.
  }
}
